import { Clickable } from '@carvana/merch-components';
import { useSelector } from 'react-redux';
import { useIsNative } from '~/context/common/DeviceContext';
import { useToggleFavorite } from '~/hooks/vdp/favorites';
import {
  getVehicleIdAndStockNumber,
  isCurrentVehicleFavorited
} from '~/selectors';
import { Heart, ThinHeart } from './Actions.styles';

type OwnProps = {
  bigHeart?: boolean;
  'data-analytics-id': string;
  'data-qa'?: string;
};

export default function Favorite({
  bigHeart = false,
  'data-analytics-id': analyticsId,
  'data-qa': qaId
}: OwnProps) {
  const { stockNumber, vehicleId } = useSelector(getVehicleIdAndStockNumber);
  const isFavorited = useSelector(isCurrentVehicleFavorited);
  const toggleFavorite = useToggleFavorite();
  const isNative = useIsNative();
  const heartClassName = bigHeart ? 'big-heart' : undefined;

  return (
    <Clickable
      className="flex items-center justify-end"
      onClick={() => toggleFavorite({ stockNumber, vehicleId })}
      data-analytics-id={analyticsId}
      data-qa={qaId}
      title="Add to Favorites"
    >
      {isNative ? (
        <Heart isFavorited={isFavorited} className={heartClassName} />
      ) : (
        <ThinHeart isFavorited={isFavorited} className={heartClassName} />
      )}
      <span className="sr-only">Add to Favorites</span>
    </Clickable>
  );
}
